module.exports = __webpack_public_path__ + "static/media/background-hero-mobile.2d156c38.svg";